import { useState, useCallback } from 'react';
import { pw9119Api } from '../../../services/pw9119Api';

export function usePW9119Navigation(
  onNavigate: (cardNo: string) => Promise<void>,
) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of card numbers */
  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await pw9119Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.f919_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
